import React, { useState, useEffect } from 'react'
import { Link, useLocation, useHistory } from 'react-router-dom'

//partials
import Table from './partials/Table'
import Filter from './partials/Filter'
import Pagination from '../../partials/Pagination'

//styles
import '../../../assets/css/outlets.css'

import loader from '../../../assets/img/app/loader.svg'
import Api from '../../../helpers/Api'
import { useAuthContext } from '../../../contexts/AuthContext'

let timeout

function Index(props) {

    const location = useLocation()
    const history = useHistory()
    const auth = useAuthContext()

    const searchParams = new URLSearchParams(location.search)

    const tabGroup = searchParams.get('current')
        ? 'current'
        : searchParams.get('expiring')
            ? 'expiring'
            : searchParams.get('objects')
                ? 'objects'
                : searchParams.get('closed')
                    ? 'closed'
                    : searchParams.get('canceled')
                        ? 'canceled'
                        : searchParams.get('companies')
                            ? 'companies'
                            : searchParams.get('owners')
                                ? 'owners'
                                : ''

    if (tabGroup === '') {
        if (auth.canViewExpiringLicenses()) {
            history.replace('/tourism?expiring=1&page=1')
        } else {
            history.replace('/tourism?current=1&page=1')
        }
    }

    const [data, setData] = useState({
        items: [],
        pages: 1,
        page: searchParams.get('page') || 1,
        total: 0,
        count: 0,
        procedures: 0,
        loading: true,
        refresh: false,
        filter: {
            requestNo: searchParams.get('requestNo') || '',
            orderNo: searchParams.get('orderNo') || '',
            object: searchParams.get('object') || '',
            company: searchParams.get('company') || '',
            eik: searchParams.get('eik') || '',
            street: searchParams.get('street') || '',
            startDate: searchParams.get('startDate') || '',
            endDate: searchParams.get('endDate') || '',
            sort: searchParams.get('sort') || ''
        }
    })


    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        setData(prev => ({
            ...prev,
            page: 1
        }));
    }, [tabGroup])

    useEffect(() => {

        clearTimeout(timeout);

        timeout = setTimeout(() => {
            loadData();

            let url = location.pathname + '?' + tabGroup + '=1'

            Object.entries(data.filter).forEach(p => {
                if (p[1]) url += '&' + (p[0] + '=' + p[1])
            })

            if (data.refresh) {
                url += (url.indexOf('?') > -1 ? '&' : '?') + 'reload=' + data.refresh
            }

            url += '&page=' + data.page

            history.replace(url)
        }, 100)

    }, [tabGroup, data.filter, data.refresh, data.page])

    useEffect(() => {
        return clearTimeout(timeout)
    }, [])

    const loadData = () => {

        if (!tabGroup) {
            return;
        }

        setData(prev => ({
            ...prev,
            loading: true
        }))

        let url = 'procedures/categorization'
            + '?group=' + tabGroup
            + '&requestNo=' + data.filter.requestNo
            + '&orderNo=' + data.filter.orderNo
            + '&object=' + data.filter.object
            + '&company=' + data.filter.company
            + '&eik=' + data.filter.eik
            + '&street=' + data.filter.street
            + '&startDate=' + data.filter.startDate
            + '&endDate=' + data.filter.endDate
            + '&sort=' + data.filter.sort
            + '&page=' + data.page

        Api.get(url)
            .then(res => {
                setData(prev => ({
                    ...prev,
                    items: res.data.items,
                    pages: res.data.pages,
                    total: res.data.total,
                    count: res.data.count,
                    loading: false
                }))
            })
    }

    const refreshData = () => {
        setData(prev => ({
            ...prev,
            refresh: new Date().getTime(),
            loading: true,
            page: 1,
            total: 0,
            count: 0,
            procedures: 0,
            items: []
        }))
    }

    const filterData = (e, name, val, timeoutDuration = 0) => {
        e.preventDefault()

        clearTimeout(timeout)

        timeout = setTimeout(() => {
            setData(prev => ({
                ...prev,
                page: 1,
                filter: {
                    ...prev.filter,
                    [name]: val
                }
            }))
        }, timeoutDuration)

    }

    const handlePage = page => setData(prev => ({ ...prev, page: page.selected + 1 }))

    return (
        <section id="outlets">
            <div className="wrapper top row">
                <h1>
                    {tabGroup === 'current' ?
                        `Текущи процедури (${data.count})`
                        :
                        tabGroup === 'expiring' ?
                            `С изтичащи разрешения (${data.count})`
                            :
                            tabGroup === 'objects' ?
                                `Активни обекти (${data.count})`
                                :
                                tabGroup === 'closed' ?
                                    `Неактивни обекти (${data.count})`
                                    :
                                    tabGroup === 'canceled' ?
                                        `С отказана процедура (${data.count})`
                                        :
                                        tabGroup === 'companies' ?
                                            `Заявления по фирми (${data.count})`
                                            :
                                            tabGroup === 'owners' ?
                                                `Заявления по собственици (${data.count})`
                                                :
                                                ''
                    }


                </h1>
                {auth.canWriteRequest() &&
                    <button className="btn-add multiple-add">
                        Ново заявление
                        <ul>
                            <li>
                                <Link to="/tourism/create/restaurant">
                                    Заведения за хранене
                            </Link>
                            </li>
                            <li>
                                <Link to="/tourism/create/hotel">
                                    Места за настаняване
                            </Link>
                            </li>
                        </ul>
                    </button>
                }
            </div>
            <div className="wrapper">
                <div className="row">
                    <Filter
                        filter={data.filter}
                        filterData={filterData}
                    />
                </div>
                {data.loading
                    ?
                    <img src={loader} alt="loading" />
                    : data.items.length === 0
                        ? <p className="no-info">
                            {tabGroup === 'expiring' ?
                                'Няма обекти с изтичащи разрешения'
                                :
                                'Няма намерени данни'
                            }
                        </p>
                        :
                        <>
                            <div className="row">
                                <Table
                                    tabGroup={tabGroup}
                                    data={data.items}
                                    refreshData={refreshData}
                                />
                            </div>
                            <div className="row">
                                <Pagination
                                    page={data.page}
                                    pages={data.pages}
                                    handlePage={handlePage}
                                />
                            </div>
                        </>
                }

            </div>

        </section>
    )
}

export default Index